// routes
import React, { createContext, useEffect, useState } from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useJsApiLoader } from '@react-google-maps/api';

import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';

// components
import ScrollToTop from './components/ScrollToTop';
import { encryptStorage, setItemInL } from './CustomStorage';
import { APP_CONSTANTS } from './URLConstants';
import { useAuth } from './components/customContextProviders/AuthContext';

export const useAuthCheck = () => {
  const { sessionUserData } = useAuth();

  return {
    isAuthenticated: !!sessionUserData,
    sessionUserData
  };
};

export const ThemeContext = createContext(null);

export default function App() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAbybENfdyMGCPsngwnjYN2rIgIKcmsa40",
    libraries: ['places']
  });

  const { fetchAllBranchesAndregion, fetchOrganizations, sessionUserData, fetchTaxonomyDetails } =
    useAuth();
  const { isAuthenticated } = useAuthCheck();

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    if (encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS) === undefined) {
      setItemInL(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
    }

    if (encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_P_DASHBOARD) === undefined) {
      setItemInL(APP_CONSTANTS.L_KEY_OF_P_DASHBOARD, 'SOUNDBOX');
    }

    if (isAuthenticated) {
      // fetchAllBranchesAndregion();
      if (sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN) {
        fetchOrganizations();
      }
      if (sessionUserData?.user?.taxonomyId) {
        fetchTaxonomyDetails(sessionUserData?.user?.taxonomyId);
      }
    }
  }, []);

  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <ThemeContext.Provider value={isLoaded}>
        <Router />
        {!isOnline && (
          <div
            style={{
              position: 'fixed',
              bottom: 0,
              width: '100%',
              backgroundColor: '#ffc6c6',
              color: 'black',
              textAlign: 'center',
              padding: '10px',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            <WarningAmberRoundedIcon />
            You are offline. Please check your internet connection.
          </div>
        )}
      </ThemeContext.Provider>
    </ThemeConfig>
  );
}
